export const volumeRegex = /(?:(\d+)x)?(\d+)ml/i;
// will detect 2x10ml values and split into: [2x10ml, 2, 10]

export const thcRegex = /THC\s*([><]*)(\d*[.,]?\d*)%/i;
// will detect THC 10% and split into: [THC 10%, 10]

export const cbdRegex = /CBD\s*([><]*)(\d*[.,]?\d*)%/i;
// will detect CBD 10% and split into: [CBD 10%, 10]
